export default function getUserLabel(userData, showAvatar, customStyle) {
  if (showAvatar === void 0) {
    showAvatar = true;
  }
  if (customStyle === void 0) {
    customStyle = "";
  }
  const username = userData.displayName() || '?';
  const avatarUrl = userData.avatarUrl();
  let output = "";
  const isMobile = window.zivenCore.isMobile();
  const userAvatar = userData.attribute("avatarUrl");
  const eventUserColor = userData.attribute("eventUserColor") || "";
  const userID = userData.id();
  let content = "";
  if (showAvatar) {
    if (avatarUrl) {
      output += "<img src='" + userAvatar + "' class='userLabelAvatar' />";
    } else {
      content = username.charAt(0).toUpperCase();
      output += "<block class='userLabelAvatar' style='background:" + userData.color() + "'>" + content + "</block>";
    }
  }
  const userNickName = userData.attribute("displayName");
  output += "<span class='username'>" + userNickName + "</span>";
  output = "<block class='userLabelContainer' userID='" + userID + "' userColor='" + eventUserColor + "' style='" + customStyle + "'>" + output + "</block>";
  return output;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/getUserLabel', getUserLabel);